import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import GUI from 'lil-gui'
//import typefaceFont from 'three/examples/fonts/optimer_bold.typeface.json'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import fluffyUrl from '../models/2FinalCharacter_fluffy.glb?url'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'
import environmentUrl from '../models/studio_kontrast_04_1k.hdr?url'
import { depth } from 'three/tsl'
/**
 * Base
 */
// Debug
//const gui = new GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

//Axes Helper
//const axesHelper = new THREE.AxesHelper()
//scene.add(axesHelper)
// Background
//scene.background = new THREE.Color('#77ff00')

// Lights
const ambientLight = new THREE.AmbientLight(0xffffff, 0.4)
scene.add(ambientLight)

const directionalLight = new THREE.DirectionalLight(0xffffff, 1.5)
directionalLight.position.set(3, 4, 5)
scene.add(directionalLight)

const rgbeLoader = new RGBELoader()

rgbeLoader.load(
    environmentUrl,
    (environmentMap) =>
    {
        environmentMap.mapping = THREE.EquirectangularReflectionMapping

        scene.environment = environmentMap
        scene.background = new THREE.Color('#f9e8de')
        

        console.log('HDRI GELADEN')
    },
    undefined,
    (error) =>
    {
        console.error('HDRI FEHLER:', error)
    }
)

const gltfLoader = new GLTFLoader()

let fluffyMixer = null

gltfLoader.load(
    fluffyUrl,
    (gltf) =>
    {
        const fluffy = gltf.scene
        scene.add(fluffy)

        fluffy.position.set(0, 0, 0)
        fluffy.scale.set(1, 1, 1)

        console.log('Animationen:', gltf.animations)

        // Blender-Animation abspielen
        if (gltf.animations.length > 0)
        {
            fluffyMixer = new THREE.AnimationMixer(fluffy)

            gltf.animations.forEach((clip) =>
            {
                const action = fluffyMixer.clipAction(clip)
                action.play()
            })
        }
    }
)
/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()
const matcapTexture = textureLoader.load('/textures/matcaps/matcap-revised.png')
matcapTexture.colorSpace = THREE.SRGBColorSpace

const donutMatcapTexture = textureLoader.load('/textures/matcaps/matcap-revised2.png')
donutMatcapTexture.colorSpace = THREE.SRGBColorSpace

/**
 * Fonts
 */
const fontLoader = new FontLoader()

fontLoader.load(
'/fonts/helvetiker_bold.typeface.json',
(font) =>
    {
       const textGeometry = new TextGeometry(
        'portfolio of Alica',
       {
        font: font,
        size: 0.5,
        depth: 0.1,
        curveSegments: 5,
        bevelEnabled: true,
        bevelThickness: 0.03,
        bevelSize: 0.02,
        bevelOffset: 0,
        bevelSegments: 4
       
       }
       
       )
        textGeometry.center()
       const portfolioGeometry = new TextGeometry(
        'coming soon',
       {
        font: font,
        size: 0.4,
        depth: 0.1,
        curveSegments: 5,
        bevelEnabled: true,
        bevelThickness: 0.02,
        bevelSize: 0.01,
        bevelOffset: 0,
        bevelSegments: 2,
       // color: '77ff00'

       }
       )
        //box um zu schauen wo die schrift tatsächlich liegt 
        //ich möchte nicht das mesh verschieben sondern die geometrie
        //auf diese weise würde sich die schrift bspw beim rotieren durch die mitte rotieren (wenn auf mitte verschoben)
        //wenn ich mesh verschiebe rotiert es an der achse usw
    
    
        //hier musss die bevelSize und beveldepthsubtrahiert werden, da sie einfluss auf die größe hat
    //    textGeometry.computeBoundingBox()
    //    console.log(textGeometry.boundingBox)
    //    textGeometry.translate(
    //     -(textGeometry.boundingBox.max.x - 0.02) * 0.5,
    //      -(textGeometry.boundingBox.max.y -0.02 )* 0.5,
    //              -(textGeometry.boundingBox.max.z -0.03)* 0.5
    // )
    //oder man nutzt center () lol
    textGeometry.center()
    portfolioGeometry.center()
    console.log(textGeometry.boundingBox)



       const textMaterial = new THREE.MeshMatcapMaterial({matcap: matcapTexture})
       //textMaterial.wireframe = true
       
       const text = new THREE.Mesh(textGeometry, textMaterial)
       text.position.y = -2.5
        scene.add(text)

     //   const portfolioMaterial = new THREE.MeshBasicMaterial({ color: 'blue'})
       //  const portfolioMaterial = new THREE.MeshBasicMaterial({ color: '#ffc800' })
       const portfolioMaterial = new THREE.MeshMatcapMaterial({matcap: matcapTexture})
        const portfolio = new THREE.Mesh(portfolioGeometry, portfolioMaterial )
        portfolioGeometry.center()
        portfolio.position.y = -3.5
        scene.add(portfolio)

        // gui.add(text.position, 'x').min(-10).max(10).step(0.01).name('text X').listen()
        //  gui.add(text.position, 'y').min(-10).max(10).step(0.01).name('text Y').listen()       
        

        //einmal geometrie und material erzeugen um es danach durch die loop zu jagen für viele
        // const donutGeometry = new THREE.TorusGeometry(0.3, 0.2, 20, 45)
        // const donutMaterial = new THREE.MeshMatcapMaterial({matcap: donutMatcapTexture})
           
        // //bei null starten, bis 100 und erhöhen bis 99
        // for (let i =0; i<500; i++)
        // {
        //      const donut= new THREE.Mesh(donutGeometry, donutMaterial)
        //    //*10 oder *100 um sie auseinanderzuziehen
        //    //-5 oder iwas um sie auch nach links zu spreaden
        //     //donut.position.x= Math.random() * 100 -5
        //     //oder:

        //     donut.position.x= (Math.random()-0.5) * 10
        //     donut.position.y= (Math.random()-0.5) * 10
        //     donut.position.z= (Math.random()-0.5) * 10

        //     //damit die donuts nicht alle nach vorne zeigen:
        //     donut.rotation.x = Math.random() * Math.PI
        //     donut.rotation.y = Math.random() * Math.PI

        //     const scale = Math.random()
        //     donut.scale.set(scale, scale, scale)
        //     scene.add(donut)
        
        // }

    }
)

         const sphereGeometry = new THREE.SphereGeometry(1.5)
        const sphereMaterial = new THREE.MeshMatcapMaterial({matcap: donutMatcapTexture})
        const sphere = new THREE.Mesh(sphereGeometry, sphereMaterial)
       // scene.add(sphere)

        const sphereRadius = 1.5
        const playerRadius= 0.15

        const playerGeometry = new THREE.SphereGeometry(playerRadius, 32,16)
        const playerMaterial = new THREE.MeshMatcapMaterial({matcap: donutMatcapTexture})
        const player = new THREE.Mesh(playerGeometry, playerMaterial)
        scene.add(player)

    //    gui.add(player.position, 'x').min(-10).max(10).step(0.01).name('Player X').listen()
    //    gui.add(player.position, 'y').min(-10).max(10).step(0.01).name('Player Y').listen()

        player.position.set(0, sphereRadius + playerRadius, 0)

        

        const keys = {}
        let cameraAttached = false 

       window.addEventListener('keydown', (event) =>
{
    keys[event.key] = true

    if (
        event.key === 'ArrowUp' ||
        event.key === 'ArrowDown' ||
        event.key === 'ArrowLeft' ||
        event.key === 'ArrowRight'
    )
    {
        cameraAttached = true
    }
})

        window.addEventListener('keyup', (event) =>
        {
            keys[event.key] = false
        })

        let latitude = 0
        let longitude = 0

        const moveSpeed = 0.02
        const playerDistance = sphereRadius + playerRadius
/**
 * Object
 */
// const cube = new THREE.Mesh(
//     new THREE.BoxGeometry(1, 1, 1),
//     new THREE.MeshBasicMaterial()
// )

// scene.add(cube)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(90, sizes.width / sizes.height, 0.1, 100)
camera.position.x = -0.0399999999999991
camera.position.y = 2.379999999999969
camera.position.z = 7.539999999999999

scene.add(camera)

// gui.add(camera.position, 'x').min(-10).max(10).step(0.01).name('Camera X').listen()
// gui.add(camera.position, 'y').min(-10).max(10).step(0.01).name('Camera Y').listen()
// gui.add(camera.position, 'z').min(-10).max(10).step(0.01).name('Camera Z').listen()

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.addEventListener('start', () =>
{
    cameraAttached = false
}
)

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.outputColorSpace = THREE.SRGBColorSpace
renderer.toneMapping = THREE.ACESFilmicToneMapping
renderer.toneMappingExposure = 1



/**
 * Animate
 */
const clock = new THREE.Clock()
const cameraOffset = new THREE.Vector3()
const cameraDistance = 1
const cameraHeight = 0.5

const tick = () =>
{

    const deltaTime = clock.getDelta()

if (fluffyMixer)
{
    fluffyMixer.update(deltaTime)
}

   // sphere.rotation.y = elapsedTime

   if (keys['ArrowUp'])
{
    latitude -= moveSpeed
}

if (keys['ArrowDown'])
{
    latitude += moveSpeed
}

if (keys['ArrowLeft'])
{
    longitude -= moveSpeed
}

if (keys['ArrowRight'])
{
    longitude += moveSpeed
}

player.position.x =
    playerDistance * Math.sin(latitude) * Math.sin(longitude)

player.position.y =
    playerDistance * Math.cos(latitude)

player.position.z =
    playerDistance * Math.sin(latitude) * Math.cos(longitude)

        if (cameraAttached)
{
    // Richtung vom Mittelpunkt der Sphere zum Player
    const surfaceNormal = player.position.clone().normalize()

    // Richtung, in die der Player bei ArrowUp läuft
    const forward = new THREE.Vector3(
        -Math.cos(latitude) * Math.sin(longitude),
        Math.sin(latitude),
        -Math.cos(latitude) * Math.cos(longitude)
    ).normalize()

    // Kamera startet beim Player
    camera.position.copy(player.position)

    // Kamera etwas von der Oberfläche abheben
    camera.position.addScaledVector(
        surfaceNormal,
        cameraHeight
    )

    // Kamera hinter den Player setzen
    camera.position.addScaledVector(
        forward,
        -cameraDistance
    )

    // Kamera schaut auf den Player
    controls.target.copy(player.position)

    // "Oben" der Kamera folgt der Kugeloberfläche
    camera.up.copy(surfaceNormal)
}


    // Update controls
    controls.update()

   
    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()